// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"numbers-circle-1"},"nodeName":"g","children":[{"attributes":{"id":"fill1","cx":12,"cy":12,"r":10,"fill":"transparent"},"nodeName":"circle","children":[]},{"attributes":{"id":"stroke1","cx":12,"cy":12,"r":10,"stroke":"currentColor","stroke-linecap":"square","stroke-width":2},"nodeName":"circle","children":[]},{"attributes":{"id":"stroke2","stroke":"currentColor","d":"M12.3999 18V6L11.9999 6L10.3999 7.24138","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-numbers-circle-1')
export default class NumbersCircle1Icon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'numbers-circle-1',
    }
  }
}
